import clsx from "clsx";

import DropdownInput, {
  DropdownInputProps,
  OptionValue,
} from "@/components/compounds/forms/DropdownInput";
import { ColorEnum } from "@/enums";
import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./DropdownFacet.module.css";

const ref = "dropdown-facet";

interface DropdownFacetProps extends Partial<CommonProps & DropdownInputProps> {
  options: Array<OptionValue>;
  selectedValue: string;
  label: string;
  name: string;
  eventGroup?: string;
}

function useDropdownFacet(props: DropdownFacetProps) {
  const {
    eventGroup,
    selectedValue,
    options,
    id = createId(ref),
    name = `${id}_facet`,
  } = props;
  const className = clsx(styles[ref], props.className);

  return {
    className,
    eventGroup,
    hideLabel: !!props.hideLabel,
    id,
    name,
    noWrap: !!props.noWrap,
    options,
    selectedValue,
  };
}

function DropdownFacet(props: DropdownFacetProps) {
  const {
    className,
    eventGroup,
    hideLabel,
    id,
    name,
    noWrap,
    options,
    selectedValue,
  } = useDropdownFacet(props);
  const selectId = `${id}_select`;
  const dropdownProps: DropdownFacetProps = {
    color: ColorEnum.DARKGREEN,
    eventGroup,
    hideLabel,
    id: selectId,
    label: props.label,
    name,
    noWrap,
    options,
    selectedValue,
  };

  return (
    <section className={className} id={id}>
      <DropdownInput {...dropdownProps} />
    </section>
  );
}

export default DropdownFacet;
export { DropdownFacet, type DropdownFacetProps };
